export enum COOKIE_CONSENT_VALUES {
  Accepted = "accepted",
  Rejected = "rejected",
}

export const COOKIE_CONSENT_KEY = "cookieConsent";
